import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'

import reducers from './reducers'

const loggerMiddleware = createLogger({ collapsed: true })
const rootReducer = combineReducers(reducers)

let composeEnhancers = compose

// Redux devtools
if (
  process.env.NODE_ENV === 'development' &&
  typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function'
) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
}

export default function configureStore(initialState) {
  let middleware = [thunkMiddleware]
  if (process.env.NODE_ENV === 'development') middleware.push(loggerMiddleware)

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware))
  )

  return store
}



// WEBPACK FOOTER //
// ./src/lib/redux/configure-store.js